import { render, staticRenderFns } from "./PreviewTemplatesForItem.vue?vue&type=template&id=066473bb&scoped=true&"
import script from "./PreviewTemplatesForItem.vue?vue&type=script&lang=ts&"
export * from "./PreviewTemplatesForItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066473bb",
  null
  
)

export default component.exports